import ReactDOM from "react-dom";
import { CloseOutlined } from "@ant-design/icons";

const CustomModal = ({ children, isVisible, close, title, width, height, margin_left }) => {
    if (!isVisible) return <></>;
    return ReactDOM.createPortal(
        <div className="fixed z-50 w-full h-full top-0 left-0 flex justify-center items-center bg-black bg-opacity-50">
            <div className="relative p-2 bg-white rounded-lg" style={{ width, height, marginLeft: margin_left }}>
                <div className="flex justify-center items-center h-10 px-4">
                    <p className="w-full flex justify-between text-xl text-[#454545] font-bold">{title}</p>
                    <CloseOutlined onClick={close} className="text-gray-500 text-[20px]" />
                </div>
                <div>{children}</div>
            </div>
        </div>,
        document.getElementById("modal")
    );
};

export default CustomModal;
